import { browserSessionStore } from '@tassat/utility';
import axios from 'axios';

export const establishAuthCookie = async () => {
    const id_token = browserSessionStore.getItem('id_token');
    if (!id_token) {
        return;
    }

    await axios.post('/auth/session', { id_token });
};

export const clearAuthCookie = async () => {
    await axios.delete('/auth/session');
};